/* Impression SCDM — LE FILET DU BOUTON « AJOUTER A MA COMMANDE ».

   ============================================================================
   POURQUOI CE FICHIER EXISTE
   ============================================================================
   La regle absolue du projet : le bouton ne doit JAMAIS etre muet. Un client
   qui clique et ne voit rien s en va, et on ne le sait jamais. C est ce qui
   est arrive le 9 septembre 2026 sur le formulaire de soumission, et le meme
   defaut peut renaitre ici a chaque fois qu on ajoute un garde-fou.

   Le bouton d ajout porte aujourd hui SIX ecouteurs de clic, poses par six
   fichiers differents. Quatre d entre eux peuvent COUPER le clic
   (preventDefault + stopImmediatePropagation) :

     scdm-vierge.js       il manque un choix obligatoire
     scdm-resolution.js   image sous le seuil, case non cochee
     scdm-limites.js      dimension hors grille (zone rouge)
     scdm.js              ajouterDesign() fait « if (!valide().ok) return; »
                          — un retour SILENCIEUX, sans un mot

   Chacun est cense afficher son propre message. Chacun garde son encadre dans
   une VARIABLE, et aucun ne verifie que cet encadre est encore dans la page.
   Le jour ou un redessin le detache, le blocage tient et le message parle dans
   le vide : bouton muet. C est exactement le scenario du 9 septembre.

   ============================================================================
   CE QUE FAIT CE FICHIER
   ============================================================================
   Il ne bloque rien et ne corrige aucune regle. Il REGARDE.

   A chaque clic sur le bouton, il note l etat, puis il revient voir un instant
   plus tard. Si le clic n a produit NI ajout, NI message a l ecran, NI depart
   vers une autre page, il ecrit lui-meme un message qui dit ce qui se passe et
   quoi faire — et, quand la configuration sort de la grille, il mene le client
   vers la demande de soumission.

   Autrement dit : meme un cas que personne n avait prevu ne redonnera jamais
   un bouton mort.

   Charge en DERNIER depuis snippets/scdm-minimum.liquid, pour que son ecouteur
   en bulle passe apres tous les autres. */

(function () {
  'use strict';

  /* Le temps qu on laisse au clic pour produire quelque chose. L ajout est
     synchrone dans scdm.js ; les encadres des garde-fous s affichent dans la
     foulee. Une seconde couvre large sans faire attendre le client. */
  var DELAI = 1000;

  var ID = 'scdmFiletAjout';
  var PAGE_SOUMISSION = '/pages/soumission';

  /* Les encadres que les garde-fous savent afficher. S il y en a un a l ecran,
     le client a son explication : on se tait. */
  var CONNUS = ['scdmLimite', 'scdmResoAvert', 'scdmResoRappel', 'scdmAlerte'];

  var boite = null;
  var minuterie = null;
  var quitte = false;
  var avantNb = 0;
  var avantMsg = '';
  var parleA = 0;

  window.SCDM_FILET = { muets: 0, dernier: '' };

  window.addEventListener('beforeunload', function () { quitte = true; });
  window.addEventListener('pagehide', function () { quitte = true; });

  function S() { return window.SCDM; }

  function nbDesigns() {
    var s = S();
    return (s && s.commande && s.commande.length) || 0;
  }

  /* ------------------------------------------------------------- le regard */

  function vraimentVisible(el) {
    if (!el || el.id === ID) return false;
    if (!document.body.contains(el)) return false;
    if (el.hidden) return false;
    if (!el.getClientRects().length) return false;
    return (el.textContent || '').trim().length > 3;
  }

  function connuAffiche() {
    for (var i = 0; i < CONNUS.length; i++) {
      if (vraimentVisible(document.getElementById(CONNUS[i]))) return true;
    }
    var config = document.getElementById('scdmConfig');
    if (config) {
      var l = config.querySelectorAll('.scdm-manque');
      for (var j = 0; j < l.length; j++) { if (vraimentVisible(l[j])) return true; }
    }
    return false;
  }

  /* L empreinte de tout ce qui parle au client dans le configurateur. Si elle
     change entre le clic et le controle, c est qu un message est apparu. */
  function empreinteMessages() {
    var config = document.getElementById('scdmConfig') || document.body;
    var l = config.querySelectorAll(
      '#scdmLimite, #scdmResoAvert, #scdmResoRappel, #scdmAlerte, .scdm-manque, [role="alert"], [role="status"]'
    );
    var out = [];
    for (var i = 0; i < l.length; i++) {
      if (!vraimentVisible(l[i])) continue;
      out.push((l[i].id || l[i].className) + '=' + (l[i].textContent || '').trim().slice(0, 120));
    }
    return out.join(' | ');
  }

  /* ---------------------------------------------------------------- style */

  function style() {
    if (document.getElementById('scdmFiletStyle')) return;
    var s = document.createElement('style');
    s.id = 'scdmFiletStyle';
    s.textContent = [
      '.scdm-filet{margin:0 0 12px;padding:12px 14px;border-radius:10px;',
      'font-size:12.5px;line-height:1.55;border:1px solid #7A3038;background:#2A1519;color:#F0C9CE}',
      '.scdm-filet[hidden]{display:none !important}',
      '.scdm-filet .fi-t{display:block;margin:0 0 5px;font-size:13px;font-weight:600;color:#FF9AA5}',
      '.scdm-filet p{margin:0 0 7px}',
      '.scdm-filet p:last-child{margin:0}',
      '.scdm-filet b{font-weight:600;color:#FFE3E6}',
      '.scdm-filet a{font-weight:600;text-decoration:underline;color:#FF9AA5}',
      'html.scdm-jour .scdm-filet{background:#FDECEE;border-color:#E4AEB5;color:#5C2A31}',
      'html.scdm-jour .scdm-filet .fi-t{color:#96222F}',
      'html.scdm-jour .scdm-filet b{color:#3A161B}',
      'html.scdm-jour .scdm-filet a{color:#96222F}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ------------------------------------------------------------ l encadre */

  /* On le recree si le redessin l a emporte — c est la faute meme qu on est
     ici pour rattraper, on ne va pas la refaire. */
  function poser() {
    if (boite && document.body.contains(boite)) return true;
    var b = document.getElementById('scdmAjouter');
    if (!b || !b.parentNode) return false;
    boite = document.createElement('div');
    boite.className = 'scdm-filet';
    boite.id = ID;
    boite.hidden = true;
    boite.setAttribute('role', 'alert');
    b.parentNode.insertBefore(boite, b);
    return true;
  }

  function effacer() {
    if (boite && document.body.contains(boite)) {
      boite.hidden = true;
      boite.innerHTML = '';
    }
  }

  /* NE JAMAIS EFFACER SUR UN EVENEMENT FABRIQUE. Le configurateur se
     redessine tout seul et plusieurs fichiers renvoient des evenements
     « input » et « change » synthetiques (scdm-vierge.js quand il borne la
     quantite, par exemple). Notre message disparaissait dans la demi-seconde
     qui suivait son affichage : le bouton redevenait muet, et c est
     exactement ce qu on est venu empecher. On n efface donc que sur un geste
     REEL du client, et jamais dans la seconde qui suit notre message. */
  function effacerSiClient(e) {
    if (!e || !e.isTrusted) return;
    if (Date.now() - parleA < 1200) return;
    effacer();
  }

  var LIEN = '<a href="' + PAGE_SOUMISSION + '">Demander une soumission</a>';

  /* Ce qu on dit, selon ce qu on arrive a comprendre de l etat. On nomme
     toujours une action que le client peut faire tout de suite. */
  function diagnostic() {
    var s = S();

    var v = null;
    try { v = s && s.valide && s.valide(); } catch (e) { v = null; }
    if (v && !v.ok) {
      return {
        titre: 'Cette dimension ne passe pas dans la grille de prix',
        corps: (v.msg || 'Le format demandé sort de ce que le prix automatique sait chiffrer.') +
          '<p><b>On le fabrique quand même</b> — c’est le prix automatique qui ne convient pas. ' +
          'Écrivez-nous vos dimensions et on vous revient avec un prix ferme. ' + LIEN + '</p>'
      };
    }

    var b = document.getElementById('scdmAjouter');
    if (b && b.classList.contains('scdm-attente')) {
      return {
        titre: 'Il reste un choix à faire plus haut',
        corps: '<p>Un des choix du configurateur n’est pas encore fait : le visuel, le format, ' +
          'la forme de découpe, le matériau, le vernis ou la quantité. Reprenez les rangées ' +
          'de haut en bas — celle qui est réglée porte une case entourée.</p>' +
          '<p>Si vous ne voyez pas ce qui manque, ne restez pas bloqué : ' + LIEN + '.</p>'
      };
    }

    var c = null;
    try { c = s && s.calcul && s.calcul(); } catch (e) { c = null; }
    var K = window.SCDM_CUSTOM || {};
    if (c && K.AIRE_MAX && c.aire > K.AIRE_MAX) {
      return {
        titre: 'Cette dimension se fait sur soumission',
        corps: '<p>Votre pièce dépasse ce que la grille de prix couvre. Un prix automatique ' +
          'serait une extrapolation, pas un vrai prix.</p>' +
          '<p><b>On le fabrique quand même.</b> Écrivez-nous vos dimensions et on vous revient ' +
          'avec un prix ferme. ' + LIEN + '</p>'
      };
    }

    return {
      titre: 'Nous n’avons pas pu ajouter ce design',
      corps: '<p>Le clic n’a rien produit et nous ne savons pas pourquoi — c’est de notre côté, ' +
        'pas du vôtre. Essayez de recharger la page et de refaire votre choix.</p>' +
        '<p>Si ça recommence, ne perdez pas votre temps avec le formulaire : envoyez-nous ' +
        'directement vos dimensions, votre matériau et votre quantité, et on vous revient ' +
        'avec un prix ferme. ' + LIEN + '</p>'
    };
  }

  function parler() {
    if (!poser()) return;
    var d = diagnostic();
    boite.innerHTML = '<span class="fi-t">' + d.titre + '</span>' + d.corps;
    boite.hidden = false;
    parleA = Date.now();
    window.SCDM_FILET.muets += 1;
    window.SCDM_FILET.dernier = d.titre;
    if (boite.scrollIntoView) {
      boite.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  /* ----------------------------------------------------------- le controle */

  function controler() {
    minuterie = null;
    if (quitte) return;                       /* on part vers une autre page */
    if (nbDesigns() > avantNb) { effacer(); return; }   /* le design est entre */
    if (connuAffiche()) return;               /* un garde-fou a deja parle */
    if (empreinteMessages() !== avantMsg) return;       /* un message est apparu */
    parler();                                 /* personne n a rien dit : nous, si */
  }

  function accrocher() {
    /* En BULLE sur le document : on passe apres tout le monde, et on survit
       aux redessins qui remplacent le bouton. Un garde-fou qui coupe le clic
       en capture nous empeche d etre appele — on ecoute donc AUSSI en capture,
       et c est la capture qui arme la minuterie. */
    document.addEventListener('click', function (e) {
      var b = (e.target && e.target.closest) ? e.target.closest('#scdmAjouter') : null;
      if (!b) return;
      effacer();
      avantNb = nbDesigns();
      avantMsg = empreinteMessages();
      if (minuterie) clearTimeout(minuterie);
      minuterie = setTimeout(controler, DELAI);
    }, true);

    /* Le client corrige quelque chose : notre message n a plus lieu d etre. */
    var config = document.getElementById('scdmConfig');
    if (config) {
      ['input', 'change'].forEach(function (ev) {
        config.addEventListener(ev, effacerSiClient, true);
      });
    }
  }

  /* ------------------------------------------------------------ demarrage */

  function demarrer() {
    if (!document.getElementById('scdmConfig')) return;
    style();
    if (!poser()) return;
    accrocher();
  }

  function quandPret(n) {
    if (document.getElementById('scdmAjouter')) return demarrer();
    if ((n || 0) > 120) return;
    setTimeout(function () { quandPret((n || 0) + 1); }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { quandPret(0); });
  } else {
    quandPret(0);
  }
})();
